// extracted by mini-css-extract-plugin
export default {"list":"AuditionDetailRoles_list__tJ7rL","empty":"AuditionDetailRoles_empty__DyoIG"};